import { memo } from "react";
import { Text, Box, useMantineTheme } from "@mantine/core";
import {
  UnsavedMethod,
  useCatalogContext,
} from "src/api/context/CatalogContext";
import PaymentSelection from "src/components/PaymentSelection";

const borderBottom = "1px solid #DDDDDD";
function Payment() {
  const theme = useMantineTheme();
  const {
    selectedPayment,
    setselectedPayment,
    selectedCustomer,
    selectedUnsavedMethod,
  } = useCatalogContext();

  return (
    <>
      <Box sx={{ borderBottom }} pb={6} mb={8}>
        <Text size={18} fw={500}>
          Payment
        </Text>
      </Box>

      <Box
        bg={theme.colors.secondary[1]}
        p="25px 12px"
        sx={{
          maxWidth: 400,
          borderRadius: 8,
          width: "100%",
          color: theme.colors.secondary[1],
        }}
      >
        <PaymentSelection
          clientId={selectedCustomer?.client?.id}
          selectedPayment={selectedPayment}
          setselectedPayment={setselectedPayment}
          selectedUnsavedMethod={selectedUnsavedMethod}
          permittedMethods={[
            UnsavedMethod.Card,
            UnsavedMethod.Terminal,
            //UnsavedMethod.ACH,
            UnsavedMethod.Cash,
          ]}
        />
      </Box>
    </>
  );
}

export default memo(Payment);
